import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=0bc07201&scoped=true&"
import script from "./LoadingButton.js?vue&type=script&lang=js&"
export * from "./LoadingButton.js?vue&type=script&lang=js&"
import style0 from "./LoadingButton.scss?vue&type=style&index=0&id=0bc07201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc07201",
  null
  
)

export default component.exports